<script setup lang="ts"></script>

<template>
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M0.320312 10.4844C0.190104 10.3542 0.104167 10.2031 0.0625 10.0312C0.0208333 9.85417 0.0208333 9.67969 0.0625 9.50781C0.104167 9.33594 0.1875 9.1875 0.3125 9.0625L3.97656 5.39844L0.3125 1.74219C0.1875 1.61719 0.104167 1.46875 0.0625 1.29688C0.0208333 1.125 0.0208333 0.953125 0.0625 0.78125C0.104167 0.604167 0.190104 0.450521 0.320312 0.320312C0.445312 0.195312 0.59375 0.111979 0.765625 0.0703125C0.942708 0.0234375 1.11719 0.0234375 1.28906 0.0703125C1.46615 0.111979 1.61719 0.192708 1.74219 0.3125L5.39844 3.97656L9.0625 0.320312C9.1875 0.195312 9.33333 0.111979 9.5 0.0703125C9.67188 0.0234375 9.84375 0.0234375 10.0156 0.0703125C10.1927 0.111979 10.3438 0.197917 10.4688 0.328125C10.6042 0.453125 10.6927 0.604167 10.7344 0.78125C10.776 0.953125 10.776 1.125 10.7344 1.29688C10.6927 1.46875 10.6068 1.61719 10.4766 1.74219L6.82812 5.39844L10.4766 9.0625C10.6068 9.1875 10.6927 9.33594 10.7344 9.50781C10.776 9.67969 10.776 9.85417 10.7344 10.0312C10.6927 10.2031 10.6042 10.3516 10.4688 10.4766C10.3438 10.6068 10.1927 10.6953 10.0156 10.7422C9.84375 10.7839 9.67188 10.7839 9.5 10.7422C9.33333 10.7005 9.1875 10.6146 9.0625 10.4844L5.39844 6.82812L1.74219 10.4922C1.61719 10.612 1.46615 10.6953 1.28906 10.7422C1.11719 10.7839 0.942708 10.7839 0.765625 10.7422C0.59375 10.6953 0.445312 10.6094 0.320312 10.4844Z"
    />
  </svg>
</template>

<style scoped></style>
